import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

// Shared look of the cards in an Enablement V2 expanded row (Notes, Email Sequence, Action Items, ...).

export const DetailSection = styled.div`
  background-color: ${(p) => p.theme.colors.White};
  border: 1px solid ${(p) => p.theme.colors.Black};
  border-radius: 4px;
  padding: 8px 12px;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid #EAECF0;
`;

export const ExpandedSectionTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${(p) => p.theme.colors.Gray500};
`;

// Outlined header action ("View All Notes", "+ New").
export const sectionActionStyles = css`
  font-size: 11px;
  font-weight: 500;
  color: #7B5EA7;
  text-decoration: none;
  border: 1px solid #7B5EA7;
  border-radius: 4px;
  padding: 2px 8px;
  line-height: 1;

  &:hover {
    background-color: #F4EFFC;
  }
`;

export const SectionLink = styled(Link)`
  ${sectionActionStyles}
`;

export const SectionButton = styled.button`
  ${sectionActionStyles}
  background: none;
  cursor: pointer;
`;
